export default __webpack_public_path__ + "static/media/img-founders-club-welcome-collections.c65a0ca3.png";